export enum PaymentMethod {
    NETS = 'NETS_CREDIT',
    ALTAPAY = 'ALTAPAY',
    LOYALTY = 'LOYALTY',
}

export const enum NetsPaymentType {
    CREDIT_CARD = 'nets_credit_card',
    MOBILEPAY = 'nets_mobilepay',
}
